<template>
    <div class="tile is-parent is-vertical zeromp sidebar bottom-right-shadow">
    <router-link to="/dashboard">
      <img
        src="../../assets/images/virtualred-logo/acromatico-e-branco/logo-red-branco-6x.png"
        class="main-pattern menulogo"
        alt="redonline"
      />
    </router-link>
    <div id="botoes" :key="componentKey">

        <!--Painel (all)-->
      <b-button
        type="is-text is-medium"
        class="sidemenubutton"
        :class="[
          currentPage('dashadmin') || 
          currentPage('dashaluno') || 
          currentPage('dashcorretor') || 
          currentPage('dashdiretor')
          ? activeClass : '']"
        outlined
        expanded

        @click="dashboardRoute"
      >
        <b-icon class="sidemenuicon icon-painel"></b-icon>
        <p class="sidemenutext">Painel</p>
      </b-button>

      <!--Minhas Correções (Corretor)-->
    <b-button v-if="corretor()"
        type="is-text is-medium"
        class="sidemenubutton"
        :class="[currentPage('redacao')? activeClass : '']"
        outlined
        expanded
        @click="pushTo('redacao')"
      >
        <b-icon class="sidemenuicon icon-correcoes-painel"></b-icon>
        <p class="sidemenutext">Minhas Correções</p>
      </b-button>

      <!--Minhas Redações (Aluno)-->
    <b-button v-if="aluno()"
        type="is-text is-medium"
        class="sidemenubutton"
        :class="[currentPage('redacao')? activeClass : '']"
        outlined
        expanded
        @click="pushTo('redacao')"
      >
        <b-icon class="sidemenuicon icon-file"></b-icon>
        <p class="sidemenutext">Minhas Redações</p>
      </b-button>

      <!--Propostas (Aluno, Diretor, Corretor)-->
      <b-button v-if="!admin()"
        type="is-text is-medium"
        class="sidemenubutton"
        :class="[
          currentPage('proposta')
          ? activeClass : '']"
        outlined
        expanded
        @click="pushTo('proposta')"
      >
        <b-icon class="sidemenuicon icon-propostas"></b-icon>
        <p class="sidemenutext">Propostas</p>
      </b-button>

      <!--Simulados (Admin, Diretor, Alunos)-->
      <b-button v-if="!corretor()"
        type="is-text is-medium"
        class="sidemenubutton"
        :class="[
          currentPage('admin/biblioteca/simulado') ||
          currentPage('aluno/simulado') ||
          currentPage('diretor/simulado')
          ? activeClass : '']"
        outlined
        expanded
        @click="simuladoRoute"
      >
        <b-icon class="sidemenuicon icon-simulados"></b-icon>
        <p class="sidemenutext">Simulados</p>
      </b-button>

        <!--Escola (Admin)-->
      <b-button v-if="admin()"
        type="is-text is-medium"
        class="sidemenubutton"
        :class="[currentPage('admin/escola')? activeClass : '']"
        outlined
        expanded
        @click="$router.push({ name: 'admin/escola', params: { }})"
      >
        <b-icon class="sidemenuicon icon-escolas"></b-icon>
        <p class="sidemenutext">Escolas</p>
      </b-button>

    <!--Turmas (Admin, Diretor)-->
      <b-button v-if="admin() || diretor()"
        type="is-text is-medium"
        class="sidemenubutton"
        :class="[
          currentPage('admin/turma') ||
          currentPage('diretor/turma')
        ? activeClass : '']"
        outlined
        expanded
        @click="turmaRoute"
      >
        <b-icon class="sidemenuicon icon-turmas"></b-icon>
        <p class="sidemenutext">Turmas</p>
      </b-button>

    <!--Alunos (Admin, Diretor)-->
      <b-button v-if="admin() || diretor()"
        type="is-text is-medium"
        class="sidemenubutton"
        :class="[
          currentPage('aluno')
          ? activeClass : '']"
        outlined
        expanded
        @click="$router.push({ name: 'aluno'})"
      >
        <b-icon class="sidemenuicon icon-alunos"></b-icon>
        <p class="sidemenutext">Alunos</p>
      </b-button>

    <!--Diretores (Admin)-->
      <b-button v-if="admin()"
        type="is-text is-medium"
        class="sidemenubutton"
        :class="[currentPage('admin/diretor')? activeClass : '']"
        outlined
        expanded
        @click="$router.push({ name: 'admin/diretor', params: { }})"
      >
        <b-icon class="sidemenuicon fas fa-user-tie"></b-icon>
        <p class="sidemenutext">Diretores</p>
      </b-button>

    <!--Corretores (Admin)-->
      <b-button v-if="admin()"
        type="is-text is-medium"
        class="sidemenubutton"
        :class="[currentPage('admin/corretor')? activeClass : '']"
        outlined
        expanded
        @click="$router.push({ name: 'admin/corretor', params: { }})"
      >
        <b-icon class="sidemenuicon icon-corretor"></b-icon>
        <p class="sidemenutext">Corretores</p>
      </b-button>

    <!--Redações (Admin, Diretor, Professor)-->
      <b-button v-if="admin() || diretor() || professor()"
        type="is-text is-medium"
        class="sidemenubutton"
        :class="[
          currentPage('redacao')
          ? activeClass : '']"
        outlined
        expanded
        @click="pushTo('redacao')"
      >
        <b-icon class="sidemenuicon icon-file"></b-icon>
        <p class="sidemenutext">Redações</p>
      </b-button>

    

    <!--Editar Biblioteca (Admin)-->
      <b-button v-if="admin()"
        type="is-text is-medium"
        class="sidemenubutton"
        :class="[currentPage('admin/biblioteca')? activeClass : '']"
        outlined
        expanded
        @click=" $router.push({ name: 'admin/biblioteca', params: { }})"
      >
        <b-icon class="sidemenuicon icon-biblioteca"></b-icon>
        <p class="sidemenutext">Editar Biblioteca</p>
      </b-button>
        
        <!--hr (Aluno, Corretor)-->
      <hr v-if="aluno() || corretor()" 
        class="hr-text" data-content="Biblioteca" />

        <!--Videos (Aluno, Corretor)-->
      <b-button v-if="aluno() || corretor()"
        type="is-text is-medium"
        class="sidemenubutton"
        :class="[currentPage('aluno/videos')? activeClass : '']"
        outlined
        expanded
        @click="videosRoute"
      >
        <b-icon class="sidemenuicon icon-videoaulas"></b-icon>
        <p class="sidemenutext">Videos</p>
      </b-button>

    <!--Materiais (Aluno, Corretor) REFATORADO-->
      <b-button v-if="aluno() || corretor()"
        type="is-text is-medium"
        class="sidemenubutton"
        :class="[currentPage('biblioteca/material')? activeClass : '']"
        outlined
        expanded
        @click="$router.push({ name: 'material'})"
      >
        <b-icon class="sidemenuicon icon-materiais"></b-icon>
        <p class="sidemenutext">Materiais</p>
      </b-button>

    <!--Coletâneas (Aluno)-->
      <b-button v-if="aluno()"
        type="is-text is-medium"
        class="sidemenubutton"
        :class="[currentPage('aluno/coletaneas')? activeClass : '']"
        outlined
        expanded
        @click="$router.push({ name: '', params: { cargo_id }}), isComponentModalActive = true"
      >
        <b-icon class="sidemenuicon icon-coletaneas"></b-icon>
        <p class="sidemenutext">Coletâneas</p>
      </b-button>


        <!--Tutoriais (Aluno, Corretor)-->
        <!--TODO: ARRUMAR LINK-->
      <a v-if="aluno() || corretor()"
        href="https://virtualred-buck.s3-sa-east-1.amazonaws.com/VirtualRed/tutorial-virtual-red.pdf"
        target="_blank"
      >
        <b-button
          type="is-text is-medium"
          class="sidemenubutton"
          :class="[currentPage('aluno/tutoriais')? activeClass : '']"
          outlined
          expanded
        >
          <b-icon class="sidemenuicon icon-tutoriais"></b-icon>

          <p class="sidemenutext">Tutoriais</p>
        </b-button>
      </a>

      <!--Nova Redação (Aluno)-->
      <b-button v-if="aluno()"
        id="new-register"
        type="is-text is-medium"
        class="sidemenubutton"
        :class="[currentPage('redacao/create')? activeClass : '']"
        outlined
        expanded
        @click="$router.push({ name: 'redacao/create', params: { cargo_id }})"
      >
        <b-icon class="sidemenuicon icon-addcircle"></b-icon>

        <p class="sidemenutext">Nova Redação</p>
      </b-button>

    <!--Orientações (Corretor)-->
    <b-button v-if="corretor()"
        type="is-text is-medium"
        class="sidemenubutton"
        :class="[currentPage('corretor/orientacoes')? activeClass : '']"
        outlined
        expanded
        @click="$router.push({ name: '', params: { cargo_id }}), isComponentModalActive = true"
      >
        <b-icon class="sidemenuicon icon-orientacoes"></b-icon>
        <p class="sidemenutext">Orientações</p>
      </b-button>





    <!--Drop Down-->
    <!--
      <b-dropdown hoverable aria-role="list" class="is-up">
        <b-button
          id="new-register"
          slot="trigger"
          type="is-text is-medium"
          class="sidemenubutton"
          outlined
          expanded
        >
          <b-icon class="sidemenuicon icon-addcircle"></b-icon>

          <p class="sidemenutext">Novo Cadastro</p>
        </b-button>

        <b-dropdown-item value="option1" aria-role="listitem">
          <span>Option 1</span>
        </b-dropdown-item>

        <b-dropdown-item value="option1" aria-role="listitem">
          <span>Option 1</span>
        </b-dropdown-item>

        <b-dropdown-item value="option1" aria-role="listitem">
          <span>Option 1</span>
        </b-dropdown-item>

        <b-dropdown-item value="option1" aria-role="listitem">
          <span>Option 1</span>
        </b-dropdown-item>
      </b-dropdown>
      -->
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      componentKey: 0,
      activeClass: "is-active"
    };
  },
  name: "SideBar",
  props: ["cargo"],
  methods: {
    currentPage(page) {
      return this.$route.path.includes(page);
    },
    pushTo(routeName){
      this.$router.push({ name: routeName});
    },
    aluno(){
      return this.cargo == 'aluno';
    },
    admin(){
      return this.cargo == 'admin';
    },
    corretor(){
      return this.cargo == 'corretor';
    },
    diretor(){
      return this.cargo == 'diretor';
    },
    professor(){
      return this.cargo == 'professor';
    },
    simuladoRoute(){
      this.admin()   ? this.$router.push({ name: 'admin/simulado', params: { }}) : (
      this.aluno()   ? this.$router.push({ name: 'aluno/simulado', params: { cargo_id: this.$route.meta.cargoId } }) : (
      this.diretor() ? this.$router.push({ name: 'diretor/simulado', params: { cargo_id: this.$route.meta.cargoId }}) : '')) 
    },
    turmaRoute(){
      this.admin()   ? this.$router.push({ name: 'admin/turma', params: { }}) : (
      this.diretor() ? this.$router.push({ name: 'diretor/turma', params: { cargo_id: this.$route.meta.cargoId }}) : '')
    },
    //redacaoRoute(){
    //  this.admin()   ? this.$router.push({ name: 'admin/redacao', params: { }}) : (
    //  this.diretor() ? this.$router.push({ name: 'diretor/redacao', params: { cargo_id: this.$route.meta.cargoId }}) : '')
    //},
    videosRoute(){
      this.aluno()    ? this.$router.push({ name: 'aluno/videos',  params: { cargo_id: this.$route.meta.cargoId }}) : (
      this.corretor() ? '' /* sem link *//*this.$router.push({ name: 'diretor/redacao', params: { cargo_id: this.$route.meta.cargoId }})*/ : '')
    },
    dashboardRoute(){
      this.admin() ? this.$router.push({ name: 'dashadmin'}) : (
      this.aluno() ? this.$router.push({ name: 'dashaluno'}) : (
      this.corretor() ? this.$router.push({ name: 'dashcorretor'}) : (
      this.diretor() ? this.$router.push({ name: 'dashdiretor'}) : 
      this.$router.push({ name: 'dashboard'}) )));
    }
  },
  created(){
  },
  mounted: function() {},
};
</script>